import React, { useContext } from 'react';
import { RegularButton, IconButton, useMediaQuery, Icon } from 'fronton-react';
import { BookmarkSimpleIcon } from '@fronton/icons-react';
import { DataContext } from 'entries/common/widgets/context';
import { useIsLaminateCalculator } from 'pages/dimensions/hooks/use-is-laminate-calculator.hook';
import { Snackbar } from 'pages/common/components/Snackbar';
import { useToggleProjectStatus } from './hooks/use-toggle-project-saving';

export const AddToShoppingList = () => {
  const isLaminateCalculator = useIsLaminateCalculator();
  const remoteData = useContext(DataContext);
  const isMobile = useMediaQuery({
    maxWidth: 767,
  });
  const {
    isProjectSaved,
    saveProjectToShoppingList,
    removeProjectFromShoppingList,
  } = useToggleProjectStatus();

  if (!isLaminateCalculator || !remoteData?.isSaveProjectEnable) {
    return null;
  }

  const handleToggleProjectStatus = () =>
    isProjectSaved ? removeProjectFromShoppingList() : saveProjectToShoppingList();

  const getIconByProjectStatus = (isSaved: boolean) =>
    isSaved ? (
      // BookmarkSimpleIcon по какой-то причине не хочет принимать другой цвет , выкрутился так
      <Icon color="control-hover-accent">
        <BookmarkSimpleIcon type="fill" size="m" />
      </Icon>
    ) : (
      <BookmarkSimpleIcon type="outline" size="m" color="text-primary" />
    );

  return (
    <>
      {isMobile ? (
        <IconButton
          variant="primary"
          size="l"
          label="Добавить в список покупок"
          onClick={handleToggleProjectStatus}>
          {getIconByProjectStatus(isProjectSaved)}
        </IconButton>
      ) : (
        <RegularButton
          iconLeft={getIconByProjectStatus(isProjectSaved)}
          rounded
          size="m"
          variant="secondary"
          onClick={handleToggleProjectStatus}>
          Добавить в список покупок
        </RegularButton>
      )}
      <Snackbar verticalPosition={isMobile ? 'bottom' : 'top'} />
    </>
  );
};
